// @ts-strict-ignore
import React, { createContext, type ReactNode } from 'react';

import * as monthUtils from 'loot-core/src/shared/months';

export type MonthBounds = {
  start: string;
  end: string;
};

export function getValidMonthBounds(
  bounds: MonthBounds,
  startMonth: undefined | string,
  endMonth: string,
) {
  return {
    start: startMonth < bounds.start ? bounds.start : startMonth,
    end: endMonth > bounds.end ? bounds.end : endMonth,
  };
}

type MonthsContextProps = {
  months: string[];
  type: string;
};

export const MonthsContext = createContext<MonthsContextProps>(null);

type MonthsProviderProps = {
  startMonth: string | undefined;
  numMonths: number;
  monthBounds: MonthBounds;
  sparseMonths?: string[];
  type: string;
  children: ReactNode;
};

export function MonthsProvider({
  startMonth,
  numMonths,
  monthBounds,
  sparseMonths,
  type,
  children,
}: MonthsProviderProps) {
  let months: string[];
  if (sparseMonths && sparseMonths.length > 0) {
    const startIdx = sparseMonths.indexOf(startMonth);
    months = startIdx >= 0 ? sparseMonths.slice(startIdx, startIdx + numMonths) : [];
  } else {
    const endMonth = monthUtils.addMonths(startMonth, numMonths - 1);
    const bounds = getValidMonthBounds(monthBounds, startMonth, endMonth);
    months = monthUtils.rangeInclusive(bounds.start, bounds.end);
  }

  return (
    <MonthsContext.Provider value={{ months, type }}>
      {children}
    </MonthsContext.Provider>
  );
}
